// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-cascader-node {\n  height: 0.3125rem !important;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 18>"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B","file":"categorySelector.vue","sourcesContent":[".el-cascader-node {\n  height: 0.3125rem !important;\n}"]}]);
// Exports
module.exports = exports;
